import React from 'react';
import { Logo } from '../brand/Logo';
export function Footer() {
  return <footer className="w-full border-t border-black/[0.08] bg-white px-6 py-14 lg:px-8" data-id="element-19" data-mp="eo0k3hc5hng3">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 text-center md:flex-row md:items-start md:justify-between md:text-left" data-id="element-20" data-mp="am5jyg5yhg3w">
        {/* Left — brand */}
        <div className="max-w-xs" data-id="element-21" data-mp="5msv5pvixyyo">
          <Logo markClassName="h-7 w-7" wordClassName="text-lg" data-id="element-22" data-mp="npuehmkuewi" />
          <p className="mt-4 text-sm leading-relaxed text-ink/55" data-id="element-23" data-mp="q2ilcixhli0">
            Building products that make everyday life happier &amp; healthier.
          </p>
        </div>

        {/* Center — HHH */}
        <div data-id="element-24" data-mp="3n1hnpxfkzeqy">
          <p className="text-2xl font-bold tracking-tightest text-ink" data-id="element-25" data-mp="3j1z2f0jul1nl">HHH</p>
          <p className="mt-2 text-sm text-vermillion" data-id="element-26" data-mp="3izw1vml2jq4m">Happy • Healthy • Humanity</p>
        </div>

        {/* Right — contact + copyright */}
        <div className="text-sm text-ink/55 md:text-right" data-id="element-27" data-mp="3939jd4g7tb5r">
          <a href="mailto:hello@haerumbah.com" className="font-medium text-ink transition-colors hover:text-vermillion" data-id="element-28" data-mp="395vypq9ckuyj">
            hello@haerumbah.com
          </a>
          <p className="mt-3" data-id="element-29" data-mp="2p5o0jr4p0dh4">© 2026 Haerumbah Pvt Ltd.</p>
          <p data-id="element-30" data-mp="2bdpy1z5hlftx">All rights reserved.</p>
        </div>
      </div>
    </footer>;
}